import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ajax_wrapper } from 'functions';

export default class ArticleAdminListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            articles: [],
            loading: true,
            error: null,
        };
        this.loadArticles = this.loadArticles.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    componentDidMount() {
        this.fetchArticles();
    }

    fetchArticles() {
        this.setState({ loading: true, error: null });
        ajax_wrapper('GET', '/api/blog/admin/articles/', {}, this.loadArticles);
    }

    loadArticles(response) {
        if (response && response.results) { // Assuming pagination from DRF
            this.setState({
                articles: response.results,
                loading: false,
            });
        } else if (response && Array.isArray(response)) { // Non-paginated list
            this.setState({
                articles: response,
                loading: false,
            });
        } else if (response && response.error) {
            this.setState({ error: response.error, loading: false });
        } else {
            this.setState({ error: 'Failed to load articles.', loading: false });
        }
    }

    handleDelete(articleSlug) {
        if (window.confirm('Are you sure you want to delete this article?')) {
            ajax_wrapper('DELETE', `/api/blog/admin/articles/${articleSlug}/`, {}, (deleteResponse) => {
                if (deleteResponse && (deleteResponse.status === 204 || deleteResponse.success)) { // status 204 for successful DELETE
                    this.fetchArticles(); // Refresh the list
                } else {
                    let errorMessage = 'Failed to delete article.';
                    if (deleteResponse && deleteResponse.error) {
                        errorMessage = deleteResponse.error;
                    } else if (deleteResponse && deleteResponse.detail) {
                        errorMessage = deleteResponse.detail;
                    }
                    this.setState({ error: errorMessage });
                    alert(`Error deleting article: ${errorMessage}`); 
                }
            });
        }
    }

    render() {
        const { articles, loading, error } = this.state;

        const pageStyle = {
            padding: '20px',
            maxWidth: '1200px',
            margin: '0 auto'
        };

        const tableStyle = {
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '20px',
        };

        const thTdStyle = {
            border: '1px solid #ddd',
            padding: '8px',
            textAlign: 'left',
        };

        const thStyle = {
            ...thTdStyle,
            backgroundColor: '#f2f2f2',
            fontWeight: 'bold'
        };

        const buttonStyle = {
            marginRight: '8px',
            padding: '5px 10px',
            textDecoration: 'none',
            display: 'inline-block',
            border: '1px solid #ccc',
            borderRadius: '4px',
            cursor: 'pointer'
        };
        
        const createButtonStyle = {
            ...buttonStyle,
            backgroundColor: '#4CAF50', /* Green */
            color: 'white',
            marginBottom: '20px'
        };

        const editButtonStyle = {
            ...buttonStyle,
            backgroundColor: '#007bff', /* Blue */
            color: 'white'
        };

        const deleteButtonStyle = {
            ...buttonStyle,
            backgroundColor: '#f44336', /* Red */
            color: 'white'
        };

        if (loading) return <div style={pageStyle}><p>Loading articles...</p></div>;
        if (error) return <div style={pageStyle}><p style={{color: 'red'}}>Error: {error}</p></div>;

        return (
            <div style={pageStyle}>
                <h1>Manage Blog Articles</h1>
                <Link to="/admin/articles/new" style={createButtonStyle}>Create New Article</Link>
                
                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <th style={thStyle}>Title</th>
                            <th style={thStyle}>Author</th>
                            <th style={thStyle}>Status</th>
                            <th style={thStyle}>Publication Date</th>
                            <th style={thStyle}>Last Updated</th>
                            <th style={thStyle}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {articles.length > 0 ? articles.map(article => (
                            <tr key={article.slug}>
                                <td style={thTdStyle}>{article.title}</td>
                                <td style={thTdStyle}>{article.author_email || 'N/A'}</td>
                                <td style={thTdStyle}>{article.status}</td>
                                <td style={thTdStyle}>{article.publication_date ? new Date(article.publication_date).toLocaleDateString() : '-'}</td>
                                <td style={thTdStyle}>{new Date(article.updated_at).toLocaleDateString()}</td>
                                <td style={thTdStyle}>
                                    <Link to={`/admin/articles/edit/${article.slug}`} style={editButtonStyle}>Edit</Link>
                                    <button onClick={() => this.handleDelete(article.slug)} style={deleteButtonStyle}>Delete</button>
                                </td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan="6" style={{...thTdStyle, textAlign: 'center'}}>No articles found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    }
} 